<template>
    <svg v-if="isId('svg_new_window')" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" mirror-in-rtl="true" fill="#000000" >
        <g stroke-width="0"></g>
        <g stroke-linecap="round" stroke-linejoin="round"></g>
        <g>
            <path fill="#767f91" d="M12.1.6a.944.944 0 0 0 .2 1.04l1.352 1.353L10.28 6.37a.956.956 0 0 0 1.35 1.35l3.382-3.38 1.352 1.352a.944.944 0 0 0 1.04.2.958.958 0 0 0 .596-.875V.96a.964.964 0 0 0-.96-.96h-4.057a.958.958 0 0 0-.883.6z"></path>
            <path fill="#767f91" d="M14 11v5a2.006 2.006 0 0 1-2 2H2a2.006 2.006 0 0 1-2-2V6a2.006 2.006 0 0 1 2-2h5a1 1 0 0 1 0 2H2v10h10v-5a1 1 0 0 1 2 0z"></path>
        </g>
    </svg>
    <svg v-else-if="isId('svg_close')" viewBox="0 0 24 24" class="close-icon" xmlns="http://www.w3.org/2000/svg" fill="none">
        <line x1="18" y1="6" x2="6" y2="18" stroke-width="2" stroke-linecap="round"/>
        <line x1="6" y1="6" x2="18" y2="18" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <svg v-else-if="isId('svg_edit')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path d="M535.6 85.7C513.7 63.8 478.3 63.8 456.4 85.7L432 110.1L529.9 208L554.3 183.6C576.2 161.7 576.2 126.3 554.3 104.4L535.6 85.7zM236.4 305.7C230.3 311.8 225.6 319.3 222.9 327.6L193.3 416.4C190.4 425 192.7 434.5 199.1 441C205.5 447.5 215 449.7 223.7 446.8L312.5 417.2C320.7 414.5 328.2 409.8 334.4 403.7L496 241.9L398.1 144L236.4 305.7zM160 128C107 128 64 171 64 224L64 480C64 533 107 576 160 576L416 576C469 576 512 533 512 480L512 384C512 366.3 497.7 352 480 352C462.3 352 448 366.3 448 384L448 480C448 497.7 433.7 512 416 512L160 512C142.3 512 128 497.7 128 480L128 224C128 206.3 142.3 192 160 192L256 192C273.7 192 288 177.7 288 160C288 142.3 273.7 128 256 128L160 128z"/>
    </svg>
    <div v-else-if="isId('kloyvd_infinitiv')" class="kloyvd-infinitiv">
        <span class="kloyvd-infinitiv-link">
            <a
                tabindex="0"
                @click.prevent="openDialog($event)"
                @keydown="openDialogKey($event)"
            >
                <img class="kloyvd-infinitiv-image" src="/images/info.svg" alt="Informasjon om klyvd infinitiv" /> <em>kløyvd infinitiv: -a</em>
            </a>
        </span>
        <dialog :id="getInfinitivBlockId()" ref="kloyvdinfinitivdialogs">
            <span class="kloyvd-infinitiv-arrow-pos" v-if="!isKloyvdInfinitivMobile()"><span class="kloyvd-infinitiv-arrow"></span></span>
            <div class="dialog-content-pos">
                <ContentBlocks id="kloyvd-infinitiv-content" :params="{}" />
                <button @click="closeDialogs($event)" tabindex="0" class="close-button">
                    <ContentBlocks id="svg_close" :params="{}" />
                </button>
            </div>
        </dialog>
    </div>
    <p v-else-if="isId('kloyvd-infinitiv-content')">{{ $t('message.dialog_kloyvd_infinitiv_content') }}</p>

</template>
<script>

export default {
	name: 'ContentBlocks',
    components: {
    },
    data() {
        return {
        };
    },
	props: {
        'id': String,
        'contentId': {
            required: false,
            default: ""
        },
        'params': {
            required: false,
            default: () => ({})
        },
	},
	mounted(){
        if (!this.params) {
            this.params = {};
        }
	},
	methods:{
        isId(id) {
            let value = false;
            if (this.id === id) {
                value = true;
            }

            return value;
        },
        isKloyvdInfinitivMobile() {
            let value = false;
            if (typeof this.params === "object" &&
                this.params.is_mobile !== undefined &&
                this.params.is_mobile === true) {
                value = true;
            }

            return value;
        },
        getInfinitivBlockId() {
            return this.contentId + '-kloyvd-infinitiv';
        },
        openDialogKey(event) {
            // keycode for space and enter should open dialog.
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();
                this.openDialog(event);
            }
        },
        openDialog(event) {
            const divBlock = event.target.closest('div');
            if (divBlock) {
                let dialogEl = divBlock.querySelectorAll('dialog').item(0);
                if (dialogEl) {
                    if (dialogEl.open === true) {
                        dialogEl.open = false;
                    } else {
                        dialogEl.open = true;
                        document.addEventListener('click', this.handleCloseDialogClick);
                        document.addEventListener('keydown', this.handleCloseDialogClick);
                    }
                }
            }
        },
        handleCloseDialogClick(e) {
            let eTargetId = '';
            if (e.constructor.name === 'KeyboardEvent') {
                // Only handle escape character
                if (e.keyCode !== 27) {
                    return;
                }
            } else {
                let eTarget = e.target.closest('span.kloyvd-infinitiv-link');
                if (!eTarget) {
                    eTarget = e.target.closest('dialog');
                }

                if (eTarget) {
                    eTargetId = eTarget.closest('div.kloyvd-infinitiv').querySelectorAll('dialog').item(0).id;
                }
            }

            let isRemoved = true;
            if (typeof this.$refs.kloyvdinfinitivdialogs === 'object' &&
                this.$refs.kloyvdinfinitivdialogs.id !== undefined) {
                if (this.$refs.kloyvdinfinitivdialogs.id !== eTargetId) {
                    this.$refs.kloyvdinfinitivdialogs.open = false;
                } else {
                    isRemoved = false;
                }

            } else {
                this.$refs.kloyvdinfinitivdialogs.forEach(dialog => {
                });
            }

            if (isRemoved) {
                document.removeEventListener('click', this.handleCloseDialogClick);
                document.removeEventListener('keydown', this.handleCloseDialogClick);
            }
        },
        closeDialogs(event) {
            let dialogElements = event.target.closest('body').querySelectorAll('dialog');

            for (let i = 0; i < dialogElements.length; i++) {
                let item = dialogElements[i];
                item.open = false;
            }
        }

    },
    computed: {
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleCloseDialogClick);
        document.removeEventListener('keydown', this.handleCloseDialogClick);
    }
}
</script>
